import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'
import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { AgnosticUserRepository } from 'auth/infra/AgnosticUserRepository'
import { MagicLinkUserRepository } from 'auth/infra/MagicLinkUserRepository'
import { createUserRepository } from 'auth/infra/userRepository'
import { isOnPortalLinkRoute } from 'rate-command-center/infra/isOnPortalLinkRoute'

import { createRfpGuideInviteInterceptor } from './createRfpGuideInviteInterceptor'

export function createRfpGuideHttpClient() {
  const storage = new LocalStorageClient()
  // On /portal-link/* the invite token is ignored: it may be scoped to another shipper.
  const linkUserRepository = isOnPortalLinkRoute()
    ? new MagicLinkUserRepository({ storage })
    : new AgnosticUserRepository({ storage })
  const sessionUserRepository = createUserRepository({ storage })

  return new HttpClient(API_URL, {
    requestInterceptor: createRfpGuideInviteInterceptor({
      inviteUserRepository: linkUserRepository,
      sessionUserRepository,
    }),
  })
}
